import type { EditPlayerFormValues } from './types'

/** BE `invalid_fields` snake_case keys → Edit Player form field names. */
export const BE_TO_FORM_FIELD: Record<string, keyof EditPlayerFormValues> = {
  name_first: 'firstName',
  name_last: 'lastName',
  birth_date: 'birthDate',
  height: 'heightFt',
  weight: 'weight',
  email: 'email',
  phone_number: 'phoneNumber',
  alternate_phone_number: 'alternatePhoneNumber',
  preferred_contact_method: 'preferredContactMethod',
  emergency_contact_name: 'emergencyContactName',
  emergency_contact_relationship: 'emergencyContactRelationship',
  emergency_contact_phone_number: 'emergencyContactPhone',
  league_registration_number: 'leagueRegistrationNumber',
  hockey_usa_number: 'hockeyUsaNumber',
  hockey_canada_number: 'hockeyCanadaNumber',
  custom_membership_number: 'customMembershipNumber',
  loyalty_number: 'loyaltyNumber',
  gender_id: 'genderId',
  'address.street_1': 'addressStreet1',
  'address.street_2': 'addressStreet2',
  'address.city': 'addressCity',
  'address.postal_code': 'addressPostalCode',
  'address.province_id': 'addressProvinceId',
  'address.country_id': 'addressCountryId',
}
